import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import LocalStorageBackend from "i18next-localstorage-backend";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import TAXI_PARAMS from "../utils/build";

const options = {
  prefix: "i18next_res_",

  expirationTime: 7 * 24 * 60 * 60 * 1000,

  defaultVersion: "",

  versions: {},

  store: window.localStorage,
};

i18n
  .use(Backend)

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    lng: TAXI_PARAMS.DEFAULT_LANG,
    fallbackLng: TAXI_PARAMS.DEFAULT_LANG,
    debug: true,
    whitelist: ["de", "en", "ru", "he"],
    detection: options,

    interpolation: {
      escapeValue: false,
    },
    backend: {
      backends: [LocalStorageBackend, XHR],
    },
  });

export default i18n;
